import { baseURL } from "../utils/url";


export const Signin = async (body) => {
    try {
        const fetchResponse = await fetch(baseURL + "LoginMerchant", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};
export const getAllVoucher = async (clientId,customerid) => {
    try {
        const fetchResponse = await fetch(baseURL + `GetVuchers?clientId=${clientId}&customerid=${customerid}`, {
            method: "GET",
            headers: {
              
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};
export const SignUP = async (body) => {
    try {
        const fetchResponse = await fetch(baseURL + "PostMerchant", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const updateMerchants = async (body) => {
    try {
        const fetchResponse = await fetch(baseURL + "UpdateMerchant", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};



export const OTPConfirm = async (opt,code) => {
    try {
        const fetchResponse = await fetch(baseURL + `ConfirmMerchant?opt=${opt}&code=${code}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};


export const contactus = async (body) => {
    try {
        const fetchResponse = await fetch(baseURL + "ContactUs", {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
            body: JSON.stringify(body),
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const forgetPassword = async (email) => {
    try {
        const fetchResponse = await fetch(baseURL + `SendOtpForFOrgetPassword?email=${email}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};


export const resetPassword = async (email ,password,otp) => {
    try {
        const fetchResponse = await fetch(baseURL + `ForgetPassword?email=${email}&password=${password}&otp=${otp}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const changepassword = async (email ,password,otp) => {
    try {
        const fetchResponse = await fetch(baseURL + `ChangePassword?email=${email}&password=${password}`, {
            method: "POST",
            headers: {
                'Content-Type': 'application/json',
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};

export const getDashboard = async ( mid) => {
    try {
        const fetchResponse = await fetch(baseURL + `GetDashboard/${mid}`, {
            method: "GET",
            headers: {
              
                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};
export const getMerchantData = async (merchantId) => {
    try {
        const fetchResponse = await fetch(baseURL + `GetMerchants?merchantId=${merchantId}`, {
            method: "POST",
            headers: {

                Accept: "application/json",
                "Content-Type": "application/json",
            },
        });
        return await fetchResponse.json();
    } catch (error) {
        return error;
    }
};



